import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-load-screen',
  templateUrl: './load-screen.component.html',
  styleUrls: ['./load-screen.component.css']
})
export class LoadScreenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
